import script from "./AppSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSelector.vue?vue&type=script&setup=true&lang=ts"

import "./AppSelector.vue?vue&type=style&index=0&id=93d456c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93d456c4"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
